 export const SUPPORTED_CURRENCIES = Object.freeze({
    USD: 'USD',
    LKR: 'LKR',
});

// Number of decimal places for each currency
export const CURRENCY_DECIMALS = Object.freeze({
  USD: 2,  // $1.00 = 100 cents
  LKR: 2,  // Rs.1.00 = 100 cents
});

// Symbol for each currency
export const CURRENCY_SYMBOLS = Object.freeze({
  USD: '$',
  LKR: 'Rs.',
});

// Currencies supported by PayPal REST API
export const PAYPAL_SUPPORTED_CURRENCIES = [
  "AUD",
  "BRL",
  "CAD",
  "CNY",
  "CZK",
  "DKK",
  "EUR",
  "HKD",
  "HUF",
  "ILS",
  "JPY",
  "MYR",
  "MXN",
  "TWD",
  "NZD",
  "NOK",
  "PHP",
  "PLN",
  "GBP",
  "RUB",
  "SGD",
  "SEK",
  "CHF",
  "THB",
  "USD",
];

// Stripe supported currencies
export const STRIPE_SUPPORTED_CURRENCIES = [
  "USD", "EUR", "GBP", "INR", "CAD", "AUD", "JPY",
  "KRW", "SGD", "HKD", "MYR", "THB", "PHP", "NZD"
];

// Payhere supported currencies
export const PAYHERE_SUPPORTED_CURRENCIES = [
  "LKR"
];

// Check if currency is supported by gateway
export const isCurrencySupportedByGateway = (currency, gateway) => {
  if (gateway === "stripe") {
    return STRIPE_SUPPORTED_CURRENCIES.includes(currency);
  } else if (gateway === "paypal") {
    return PAYPAL_SUPPORTED_CURRENCIES.includes(currency);
  }
  return false;
};